<template>
  <v-snackbar
    app
    top
    :left="!isMobile"
    :color="color"
    vertical
    multi-line
    v-model="show"
    :timeout="timeout"
    class="text-center ma-2"
  >
    {{ message }}
    <template v-slot:action="{ attrs }">
      <v-btn color="#171717" text v-bind="attrs" @click="show = false">Fermer</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data: () => ({
    show: false,
    message: "",
    color: "",
    timeout: 2500,
    isMobile: false
  }),
  methods: {
    onResize() {
      this.isMobile = this.ismobile();
    }
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "notificationModule/NOTIFY") {
        this.message = state.notificationModule.content;
        this.color = state.notificationModule.color;
        this.show = true;
      }
    });
  }
};
</script>

<style>
@media screen and (min-width: 910px) {
  .v-snack--top {
    top: 90px !important;
  }
}
</style>